const key = "randomizer-settings";

export const setRandomizerSettingsLocalStorage = (
  minRange: string,
  maxRange: string,
  delay: string
) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      minRange,
      maxRange,
      delay,
    })
  );
};

export const getRandomizerSettingsLocalStorage = (): {
  minRange: string;
  maxRange: string;
  delay: string;
} => {
  const data = localStorage.getItem(key);

  if (data === null) {
    return {
      minRange: "0",
      maxRange: "100",
      delay: "5",
    };
  } else {
    return JSON.parse(data);
  }
};
